<template>
  <div style="display: block" class="uk-modal uk-open uk-animation-fade uk-animation-fast tm-modal-center">
    <div class="uk-modal-dialog uk-modal-body">
      <div class="uk-text-center">
        <div v-html="local_page_keys.warning_close_order"></div>
        <p class="uk-margin-medium-top">
        <button type="button" class="uk-button uk-button-danger uk-margin-small-right" @click="reload">
          {{ local_page_keys.button_ok }}
        </button>
        <button type="button" class="uk-button-success uk-button" @click="closeModal">
          {{ local_page_keys.button_cancel }}
        </button>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name:'ModaWarningCloseOrderForRetoucherDialog',
  data() {
    return {};
  },
  props: {
    local_page_keys: {
      type: Object,
      require: true
    },
  },
  methods: {
    closeModal() {
      this.$emit('close', true);
    },
    reload() {
      this.$emit('reload', true);
    },
  },
}
</script>